import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, DatePicker, Space, Spin } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../../utils/messages";
import { hasText } from "../../../../utils/utilsFunctions";
import { IMandatoFuncaoEspecial, IFuncaoEspecialMandato } from "../../Componentes/InterfaceMandato";

import { obterFuncoesEspeciais } from "../../../../services/apiAuxiliar";
import { hasPermissao, Papel } from "../../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  mandatoFuncaoEspecial: IMandatoFuncaoEspecial[];
  setMandatoFuncaoEspecial: React.Dispatch<React.SetStateAction<IMandatoFuncaoEspecial[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const { Option } = Select;

const DiretorFuncaoEspecial = ({ form, mandatoFuncaoEspecial, setMandatoFuncaoEspecial, manter }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalFuncEsp, setExibirModalEx] = useState(false);
  const [exibirFuncaoEspecialMandato, setExibirFuncaoEspecialMandato] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);

  useEffect(() => {
    if (mandatoFuncaoEspecial.length === 0) {
      setExibirFuncaoEspecialMandato("none")
    } else {
      setExibirFuncaoEspecialMandato("inline")
    }
  }, [mandatoFuncaoEspecial]);


  useEffect(() => {
    if (manter === 2 ||  manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("matriculaEfpc"))) {
      mostrarInfo("Não é possível incluir nova função especial", "Entidade não informada");
    } else if (!hasText(form.getFieldValue("nmCargo"))) {
      mostrarInfo("Não é possível incluir nova função especial", "Nome do cargo não informado");
    } else if (!hasText(form.getFieldValue("dtInicioMandato"))) {
      mostrarInfo("Não é possível incluir nova função especial", "Datas de mandato não informadas");
    } else {
      if (botao === "cancelar") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEx(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2 ||  manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarFuncaoEspecial = () => {

    form
      .validateFields([
        "idFuncaoEspecial",
        "nmFuncaoEspecial",
        "dtInicioFuncEsp",
        "dtFimFuncEsp",
      ])
      .then(() => {
        setDadosValidados(true);
        controleDaGrid("incluir");
        setDadosFuncaoEspecial();
      })
      .catch((error) => {
        if (!dadosValidados) {
          errorMessage("Campo obrigatório não preechido ou não validado");
        } else {
          errorMessage(error.message);
        }
        setDadosValidados(false);
      });

  };

  const setDadosFuncaoEspecial = () => {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setMandatoFuncaoEspecial(pre => {
        return pre.map(funcEsp => {
          if (funcEsp.emEdicao) {
            return ({
              idMandatoFuncaoEspecial: estadoModal === 3 ? Number(form?.getFieldValue("idMandatoFuncaoEspecial")) : -1,
              idFuncaoEspecial: form?.getFieldValue("idFuncaoEspecial"),
              nmFuncaoEspecial: form?.getFieldValue("nmFuncaoEspecial")?.toUpperCase(),
              dtInicio: form?.getFieldValue("dtInicioFuncEsp") ? dayjs(form?.getFieldValue("dtInicioFuncEsp")).format("YYYY-MM-DD") : "",
              dtFim: form?.getFieldValue("dtFimFuncEsp") ? dayjs(form?.getFieldValue("dtFimFuncEsp")).format("YYYY-MM-DD") : "",
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return funcEsp
          }
        })
      });
    } else {
      setMandatoFuncaoEspecial([
        ...mandatoFuncaoEspecial,
        {
          idMandatoFuncaoEspecial: estadoModal === 3 ? Number(form?.getFieldValue("idMandatoFuncaoEspecial")) : -1,
          idFuncaoEspecial: form?.getFieldValue("idFuncaoEspecial"),
          nmFuncaoEspecial: form?.getFieldValue("nmFuncaoEspecial")?.toUpperCase(),
          dtInicio: form?.getFieldValue("dtInicioFuncEsp") ? dayjs(form?.getFieldValue("dtInicioFuncEsp")).format("YYYY-MM-DD") : "",
          dtFim: form?.getFieldValue("dtFimFuncEsp") ? dayjs(form?.getFieldValue("dtFimFuncEsp")).format("YYYY-MM-DD") : "",
          statusReg: 1,
          touched: true,
          emEdicao: false,
        },
      ]);
    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idMandatoFuncaoEspecial",
      "idFuncaoEspecial",
      "nmFuncaoEspecial",
      "dtInicioFuncEsp",
      "dtFimFuncEsp",
      "ativo",
    ]);
  }

  const setFieldsDetalharEditar = (IFuncaoEspecial: IMandatoFuncaoEspecial) => {
    form.setFieldsValue({
      "idMandatoFuncaoEspecial": IFuncaoEspecial.idMandatoFuncaoEspecial ? IFuncaoEspecial.idMandatoFuncaoEspecial : -1,
      "idFuncaoEspecial": IFuncaoEspecial.idFuncaoEspecial ? IFuncaoEspecial.idFuncaoEspecial : -1,
      "nmFuncaoEspecial": IFuncaoEspecial.nmFuncaoEspecial,
      "dtInicioFuncEsp": IFuncaoEspecial.dtInicio ? dayjs(IFuncaoEspecial.dtInicio) : undefined,
      "dtFimFuncEsp": IFuncaoEspecial.dtFim ? dayjs(IFuncaoEspecial.dtFim) : undefined,
    });
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Função Especial",
      dataIndex: "",
      render: (IMandatoFuncEsp: IMandatoFuncaoEspecial) => <>{IMandatoFuncEsp.nmFuncaoEspecial}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Inicial",
      dataIndex: "",
      render: (IMandatoFuncEsp: IMandatoFuncaoEspecial) => <>{dayjs(IMandatoFuncEsp.dtInicio).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Final",
      dataIndex: "",
      render: (IMandatoFuncEsp: IMandatoFuncaoEspecial) => <>{IMandatoFuncEsp.dtFim ? dayjs(IMandatoFuncEsp.dtFim).format("DD/MM/YYYY") : undefined}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IMandatoFuncEsp: IMandatoFuncaoEspecial) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 ||  manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IMandatoFuncEsp);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IMandatoFuncEsp);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  mandatoFuncaoEspecial.forEach(funcEsp => {
                    if (funcEsp === IMandatoFuncEsp) {
                      funcEsp.statusReg = 1;
                      funcEsp.touched = true;
                      funcEsp.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      funcEsp.emEdicao = false;
                    }
                  })
                  IMandatoFuncEsp.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IMandatoFuncEsp?.idMandatoFuncaoEspecial && IMandatoFuncEsp?.idMandatoFuncaoEspecial < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setMandatoFuncaoEspecial(mandatoFuncaoEspecial.filter((funcEsp) => funcEsp !== IMandatoFuncEsp));
                }}
              />
            </div>

            <div style={{ display: (IMandatoFuncEsp?.idMandatoFuncaoEspecial && IMandatoFuncEsp?.idMandatoFuncaoEspecial > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IMandatoFuncEsp?.statusReg === 1 || IMandatoFuncEsp?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IMandatoFuncEsp.touched = true; // MARCA O REGISTRO ALTERADO.
                    IMandatoFuncEsp.statusReg = (IMandatoFuncEsp.statusReg === 1 ? 2 : 1);
                    setMandatoFuncaoEspecial(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(funcEsp => {
                        if (funcEsp.idMandatoFuncaoEspecial === IMandatoFuncEsp.idMandatoFuncaoEspecial) {
                          return IMandatoFuncEsp;
                        } else {
                          return funcEsp;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IMandatoFuncEsp?.statusReg === 1 || IMandatoFuncEsp?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IMandatoFuncEsp.touched = true; // MARCA O REGISTRO ALTERADO.
                    IMandatoFuncEsp.statusReg = (IMandatoFuncEsp.statusReg === 1 ? 2 : 1);
                    setMandatoFuncaoEspecial(pre => {
                      return pre.map(funcEsp => {
                        if (funcEsp.idMandatoFuncaoEspecial === IMandatoFuncEsp.idMandatoFuncaoEspecial) {
                          return IMandatoFuncEsp;
                        } else {
                          return funcEsp;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];


  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "idFuncaoEspecial",
      "nmFuncaoEspecial",
      "dtInicioFuncEsp",
      "dtFimFuncEsp",
      "ativo",
    ]);
  };


  useEffect(() => {
    if (funcaoEspecialMandato.length === 0) getFuncaoEspecialMandato();
  }, []);

  const [funcaoEspecialMandato, setFuncaoEspecialMandato] = useState<IFuncaoEspecialMandato[]>([]);
  const getFuncaoEspecialMandato = async () => {
    const { data } = await obterFuncoesEspeciais();
    setFuncaoEspecialMandato(data);
  }


  const handlerFuncaoEspecialMandato = async (value: any) => {
    form.setFieldsValue({
      "nmFuncaoEspecial": value.children,
      "idFuncaoEspecial": value.key,
    });
  };

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirFuncaoEspecial"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirFuncaoEspecial");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Função Especial
      </Button>

      <>
        <Modal title="Incluir Função Especial" open={exibirModalFuncEsp}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarFuncaoEspecial}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Função Especial'
                    name='nmFuncaoEspecial'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "A função especial é obrigatória",
                      },
                    ]}                  >
                    <Select
                      style={{ width: 600 }}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      placeholder='Função Especial'
                      disabled={estadoModal === 2}
                      onChange={(_, index) => {
                        handlerFuncaoEspecialMandato(index);
                      }}
                    >
                      {funcaoEspecialMandato?.map((e: IFuncaoEspecialMandato) => (
                        <Option key={e.idFuncaoEspecial} value={e.idFuncaoEspecial}>
                          {e.nmFuncaoEspecial}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={8}>
                  <Form.Item label="Data Inicial"
                    name="dtInicioFuncEsp"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data inicial obrigatória",
                      },
                      {
                        validator: async (_, startDatetime) => {
                          let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                          if (dtInicioMandato && startDatetime) {
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                            if (startDatetime < dtInicioMandato) {
                              return Promise.reject(
                                "A data não pode ser anterior à Data Inicial do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data Final"
                    name="dtFimFuncEsp"
                    colon={false}
                    rules={[
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = form.getFieldValue("dtInicioFuncEsp");
                          if (startDatetime && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            if (endDatetime < startDatetime) {
                              return Promise.reject(
                                "A Data Final não pode ser anterior à Data Inicial"
                              );
                            }
                          }
                        },
                      },
                      {
                        validator: async (_, endDatetime) => {
                          let dtFimMandato = form.getFieldValue("dtFimMandato");
                          if (dtFimMandato && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                            if (endDatetime > dtFimMandato) {
                              return Promise.reject(
                                "A data não pode ser posterior à Data Final do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>

              </Row>

            </>
          </Spin>
        </Modal>

      </>

      <Row style={{ display: exibirFuncaoEspecialMandato }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" showHeader={true} columns={columns} dataSource={mandatoFuncaoEspecial} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default DiretorFuncaoEspecial;